/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FlightLookupRequest
 */
export interface FlightLookupRequest {
    /**
     * Airline IATA code (e.g. "UA")
     * @type {string}
     * @memberof FlightLookupRequest
     */
    airlineIata: string;
    /**
     * Flight number without airline prefix (e.g. "1234")
     * @type {string}
     * @memberof FlightLookupRequest
     */
    flightNumber: string;
    /**
     * Departure date in YYYY-MM-DD format
     * @type {Date}
     * @memberof FlightLookupRequest
     */
    departureDate: Date;
}

/**
 * Check if a given object implements the FlightLookupRequest interface.
 */
export function instanceOfFlightLookupRequest(value: object): value is FlightLookupRequest {
    if (!('airlineIata' in value) || value['airlineIata'] === undefined) return false;
    if (!('flightNumber' in value) || value['flightNumber'] === undefined) return false;
    if (!('departureDate' in value) || value['departureDate'] === undefined) return false;
    return true;
}

export function FlightLookupRequestFromJSON(json: any): FlightLookupRequest {
    return FlightLookupRequestFromJSONTyped(json, false);
}

export function FlightLookupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightLookupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'airlineIata': json['airline_iata'],
        'flightNumber': json['flight_number'],
        'departureDate': (new Date(json['departure_date'])),
    };
}

export function FlightLookupRequestToJSON(json: any): FlightLookupRequest {
    return FlightLookupRequestToJSONTyped(json, false);
}

export function FlightLookupRequestToJSONTyped(value?: FlightLookupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'airline_iata': value['airlineIata'],
        'flight_number': value['flightNumber'],
        'departure_date': value['departureDate'].toISOString().substring(0,10),
    };
}

